import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../api";
import { useAuth } from "../Auth/AuthContext";
import { FaBuilding, FaSignInAlt, FaUsers, FaPlus, FaArrowRight } from "react-icons/fa";

// Accueil du superadmin (org système, pas de données métier propres) : accès
// direct aux organisations clientes pour y entrer.
export default function SuperadminHome() {
  const navigate = useNavigate();
  const { impersonate } = useAuth();
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/organizations")
      .then((r) => setOrgs(r.data))
      .catch(() => toast.error("Chargement des organisations impossible"))
      .finally(() => setLoading(false));
  }, []);

  const enter = async (org) => {
    try {
      const { data } = await api.post(`/admin/organizations/${org.id}/impersonate`);
      impersonate(data.token, { id: org.id, name: org.name, slug: org.slug });
      toast.success(`Vous consultez « ${org.name} »`);
      navigate("/");
    } catch (e) {
      toast.error(e?.response?.data?.error || "Impossible d'entrer");
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 flex flex-col gap-6 py-8 animate-fade-in">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3">
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-bold tracking-widest text-primary uppercase bg-primary/10 border border-primary/20 rounded-md px-2 py-1">
            Console SaaS — Superadmin
          </div>
          <h1 className="text-3xl font-extrabold text-base-content mt-3">Organisations clientes</h1>
          <p className="text-sm text-base-content/50 mt-1">
            Vous êtes l'éditeur de la plateforme. Entrez dans une organisation pour voir et gérer ses données.
          </p>
        </div>
        <Link to="/admin/organizations" className="btn btn-primary btn-sm gap-2 self-start">
          <FaBuilding /> Gérer les organisations <FaArrowRight size={11} />
        </Link>
      </div>

      {loading ? (
        <div className="flex justify-center h-40 items-center"><span className="loading loading-spinner loading-lg text-primary" /></div>
      ) : orgs.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-base-300 p-10 text-center">
          <FaBuilding className="mx-auto text-3xl text-base-content/20 mb-3" />
          <p className="text-base-content/50 mb-4">Aucune organisation cliente pour l'instant.</p>
          <Link to="/admin/organizations" className="btn btn-primary btn-sm gap-2"><FaPlus /> Créer une organisation</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {orgs.map((o) => (
            <div
              key={o.id}
              className="group rounded-2xl border border-base-200 bg-base-100 p-5 flex flex-col gap-4 hover:border-primary/40 hover:shadow-md transition-all"
            >
              <div className="flex items-start justify-between">
                <div
                  className="flex items-center gap-3 cursor-pointer min-w-0"
                  onClick={() => navigate(`/admin/organizations/${o.id}`)}
                >
                  <div className="w-11 h-11 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center text-primary text-lg shrink-0">
                    <FaBuilding />
                  </div>
                  <div className="min-w-0">
                    <div className="font-bold text-base-content truncate group-hover:text-primary transition-colors">{o.name}</div>
                    <div className="text-xs text-base-content/45 truncate">{o.slug}</div>
                  </div>
                </div>
                <span className={`badge badge-sm ${o.status === "active" ? "badge-success" : "badge-warning"}`}>
                  {o.status === "active" ? "active" : "suspendue"}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 text-xs text-base-content/50"><FaUsers size={11} /> {o.user_count} utilisateur(s)</span>
                <button onClick={() => enter(o)} className="btn btn-primary btn-xs gap-1"><FaSignInAlt size={10} /> Entrer</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
